import type { MorphoMarketPositionValues, } from "@types";
import type { GetMarketPositionsProps, } from "./getMarketPosition";
import { getMarketPosition, } from "./getMarketPosition";

export const getMarketPositions = async ({
	wallet,
	vaults,
	force = false,
}: GetMarketPositionsProps): Promise<Record<string, MorphoMarketPositionValues|null>|null> => {

	const results = await Promise.all(vaults.map(v => getMarketPosition({ wallet, vault: v, force, })));
	return vaults.reduce((acc, v, i) => Object.assign(acc, { [v.symbol]: results[i], }), {} as Record<string, MorphoMarketPositionValues|null>);

}

